export const appRoles = {
    Admin: 1,
    Operator: 2,
    Manager: 3,
};
//# sourceMappingURL=appRoles.js.map